export default __webpack_public_path__ + "static/media/header.2d581e12.png";